// Generated by purs version 0.15.16
import * as Concur_Core_LiftWidget from "../Concur.Core.LiftWidget/index.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Effect from "../Effect/index.js";
var mempty = /* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Effect.monoidEffect(Data_Monoid.monoidUnit));
var mkNodeWidget = function (mkView) {
    return function (w) {
        return Concur_Core_Types.mkWidget(function (cb) {
            return Concur_Core_Types.runWidget(w)(function (v) {
                if (v instanceof Concur_Core_Types.View) {
                    return cb(new Concur_Core_Types.View(mkView(function (a) {
                        return cb(new Concur_Core_Types.Completed(a));
                    })(v.value0)));
                };
                if (v instanceof Concur_Core_Types.Completed) {
                    return cb(new Concur_Core_Types.Completed(v.value0));
                };
                throw new Error("Failed pattern match at Concur.Core (line 20, column 17 - line 22, column 36): " + [ v.constructor.name ]);
            });
        });
    };
};
var mkLeafWidget = function (mkView) {
    var v = function (cb) {
        return mkView(function (a) {
            return cb(new Concur_Core_Types.Completed(a));
        });
    };
    return Concur_Core_Types.mkWidget(function (cb) {
        return function __do() {
            cb(new Concur_Core_Types.View(v(cb)))();
            return mempty;
        };
    });
};
export {
    mkLeafWidget,
    mkNodeWidget
};
export {
    liftWidget
} from "../Concur.Core.LiftWidget/index.js";
export {
    Completed,
    View,
    Widget,
    mkWidget,
    runWidget,
    unWid
} from "../Concur.Core.Types/index.js";
//# sourceMappingURL=index.js.map
